import { createApp } from 'vue';

/**
 * Tracks standalone Vue app instances created for city/district SRP map pins and property cards.
 */
export function useCityMapVueApps(mapMarkersRef) {
  let propertyCardApp = null;
  const mapPinApps = [];

  const mountMapPinApp = (component, appProps, container) => {
    const app = createApp(component, appProps);
    app.mount(container);
    mapPinApps.push(app);
    return app;
  };

  const mountPropertyCardApp = (component, appProps, container) => {
    if (!container) {
      return null;
    }

    propertyCardApp?.unmount();
    const app = createApp(component, appProps);
    app.mount(container);
    propertyCardApp = app;
    return app;
  };

  const disposeAllMapApps = () => {
    mapMarkersRef.value.forEach((marker) => {
      marker.pin?.remove();
    });

    mapPinApps.forEach((app) => {
      app?.unmount();
    });
    mapPinApps.length = 0;

    propertyCardApp?.unmount();
    propertyCardApp = null;
  };

  onBeforeUnmount(() => {
    disposeAllMapApps();
  });

  return {
    mountMapPinApp,
    mountPropertyCardApp,
    disposeAllMapApps,
  };
}
